import { Link } from "react-router-dom";

const Breadcrumb = ({
  items,
  separator = "/",
  containerClassName = "",
  crumbItemClassName = "",
  linkClassName = ""
}: {
  items: { label: string; href?: string }[];
  separator?: React.ReactNode;
  containerClassName?: string;
  crumbItemClassName?: string;
  linkClassName?: string;
}) => {
  return (
    <div className={`${containerClassName} flex items-center gap-2`}>
      {items.map((item, index) => (
        <span key={index} className={`${crumbItemClassName} text-black flex items-center gap-2`}>
          {item.href ? (
            <Link
              to={item.href}
              className={`${linkClassName} flex cursor-pointer items-center gap-2 text-black hover:underline`}
            >
              {item.label}
            </Link>
          ) : (
            <span className={`${crumbItemClassName} flex items-center gap-2`}>{item.label}</span>
          )}
          {index < items.length - 1 && <span className=''>{separator}</span>}
        </span>
      ))}
    </div>
  );
};

export default Breadcrumb;
